import React from "react";
import { Link } from "react-router-dom";

import logo from "../../img/logo/alumni-tr.png";

class Footer extends React.Component {
  render() {
    return (
      <div className="container-fluid bg-dark footer">
        <footer className="container">
          <div className="text-center footer-logo">
            <img className="card-img-top " src={logo} />
          </div>
          <br />
          <br />
          <p className="float-right">
            <Link to="/Statistics">Statistics</Link>
          </p>
          <p>&copy; University of Bath 2019</p>
        </footer>
      </div>
    );
  }
}

export default Footer;
